import { FEED_SEPARATOR_CONTEXT_TYPE } from "%/dynamic-component-editor/helpers/required-context-entity-type";

// A component becomes a feed's separator by REQUIRING a context of type
// `feedItemSeparator` -- the same "+ add a required context" flow every other
// feed-mounted component uses. A story card requires a Story and the feed
// supplies it; a separator requires its label and the feed supplies that.
//
// It used to be declared as a PROVIDES-context, which read backwards: the
// component supplies nothing, it consumes a value the feed computes. Requiring
// it also means the mount path validates it like any other requirement instead
// of silently rendering an empty separator.
//
// The author names the context freely; only the TYPE identifies it, which is
// why every lookup here matches on the type and never on a reserved name.
//
// PALETTE ONLY. The element resolver keeps resolving FeedSeparatorLabel
// everywhere, so a component authored before this gate existed still renders
// its label instead of InvalidElement.
export const FEED_SEPARATOR_CONTEXT_LABEL = "Feed Separator";

// The persisted `required-contexts` entry type lives with the other value-type
// guards so one definition serves every "is this a value?" check.
export { FEED_SEPARATOR_CONTEXT_TYPE };

// What the required-context picker shows for it.
export const FEED_SEPARATOR_CONTEXT_OPTION_LABEL = "Feed Item Separator";

const KEY_REQUIRED_CONTEXTS = "required-contexts";

function collectRequiredContexts(dynamicComponent) {
  const required = dynamicComponent?.getRootOption?.(KEY_REQUIRED_CONTEXTS);
  return required && !Array.isArray(required) ? required : {};
}

// A required-context entry is the separator's when its declared type matches,
// whichever key the shape uses. `type` is what the inspector writes today;
// `entity` and `entityType` are tolerated because older stored rows used them
// and there is no migration for the required-contexts option.
export function isFeedSeparatorRequirement(entry) {
  if (!entry) {
    return false;
  }
  return [entry.type, entry.entity, entry.entityType].includes(FEED_SEPARATOR_CONTEXT_TYPE);
}

// The author-chosen NAME of the separator context, or "" when the component
// declares none. The name is what the runtime supplies the value under.
export function feedSeparatorLabelContextName(dynamicComponent) {
  const entries = Object.entries(collectRequiredContexts(dynamicComponent));
  const hit = entries.find(([, entry]) => isFeedSeparatorRequirement(entry));
  return hit ? hit[0] : "";
}

export function declaresFeedSeparatorLabel(dynamicComponent) {
  return feedSeparatorLabelContextName(dynamicComponent) !== "";
}
